export enum IdentityCardTypeEnum {
    Passport = 1,
    ForeignPassport = 2
}